import { takeLatest, put, call } from "redux-saga/effects";
import { UnautherizedResponse } from "../GetUser/GetUserActions";
import ACTIONS from "./MasterActionTypes";
import { axiosPost, axiosPut, axiosDelete, axiosGet } from "../../Utils/axios";
import {
  getMasterListResponse,
  postMasterResponse,
  putMasterResponse,
  putStatusMasterResponse,
} from "./MasterActions";

export function* onGetMasterListHelperSaga({ payload }) {
  try {
    let response = yield call(() =>
      axiosPost("master/index", payload).then((res) => res?.data)
    );

    yield put(getMasterListResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPutMasterHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPut(`master/${payload.id}`, payload).then((res) => res?.data)
    );
    yield put(putMasterResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPutStatusMasterHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPut(`master/status/${payload.id}`, payload).then((res) => res?.data)
    );
    yield put(putStatusMasterResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPostMasterHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPost("master/new", payload).then((res) => res?.data)
    );
    yield put(postMasterResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* MasterWatcherSaga() {
  yield takeLatest(ACTIONS.POST_MASTER_REQUEST, onPostMasterHelperSaga);
  yield takeLatest(ACTIONS.PUT_MASTER_REQUEST, onPutMasterHelperSaga);
  yield takeLatest(
    ACTIONS.PUT_STATUS_MASTER_REQUEST,
    onPutStatusMasterHelperSaga
  );
  yield takeLatest(ACTIONS.GET_MASTER_LIST_REQUEST, onGetMasterListHelperSaga);
}
